// extracted by mini-css-extract-plugin
export default {"section":"section--m8p_G","section__title":"section__title--DairX"};